<template>
  <div class="antv-chart-mini">
    <div class="chart-wrapper" :style="{ height: 46 }">
      <v-chart :force-fit="true" :height="height" :scale="scale" :data="bar" :padding="[36, 5, 18, 5]">
        <v-tooltip />
        <v-bar position="time*value" />
      </v-chart>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

const tooltip = [
  'time*value',
  (x, y) => ({
    name: x,
    value: y
  })
]

export default {
  name: 'MiniBar',
  props: {
    dataList: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      tooltip,
      height: 100
    }
  },
  computed: {
    bar () {
      if (this.dataList && this.dataList.length > 0) {
        return this.dataList.map(bar => {
          const a = {}
          a.time = this.moment(new Date()).from(new Date(bar.time), true) + '前'
          a.value = +bar.value
          return a
        })
      } else {
        return []
      }
    },

    scale () {
      const scale = [{
        dataKey: 'value',
        min: 10000,
        max: 0
      }]
      if (this.bar) {
        for (let i = 0; i < this.bar.length; i++) {
          if (scale[0].max < this.bar[i].value) {
            scale[0].max = this.bar[i].value
          }
          if (scale[0].min > this.bar[i].value) {
            scale[0].min = this.bar[i].value
          }
        }
        if (scale[0].min !== 0) {
          scale[0].min = scale[0].min * 9 / 10
        }
        // scale[0].max = scale[0].max * 5 / 4
      }
      return scale
    }
  },

  methods: {
    moment
  }
}
</script>

<style lang="less" scoped>
  @import "chart";
</style>
